import { ofType } from 'redux-observable';
import { EMPTY, merge, of } from 'rxjs';
import { debounceTime, filter, map, mergeMap, withLatestFrom } from 'rxjs/operators';
import { limitOrderInputFormActions } from 'state/secondaryMarket/limit-order/form/input/inputForm.actions';
import { limitOrderInputFormSelectors } from 'state/secondaryMarket/limit-order/form/input/inputForm.selectors';
import type { EpicWithThunk } from 'state/state.common';
import { getWorkspaceType } from 'state/workspaces/tabs/tabs.selector';

export function triggerAmendLimitOrderTabContentPersistenceEpic(): EpicWithThunk {
  return (actions$, state$, { scheduler }) => {
    const newForm$ = actions$.pipe(
      ofType('WORKSPACE_TAB_CREATED'),
      filter(({ workspace, tabType }) => workspace === 'secondaryMarketPostEvents' && tabType === 'limitOrder'),
      map(({ id }) => id),
    );
    const modifyForm$ = actions$.pipe(
      ofType('SECONDARY_MARKET_LIMIT_ORDER_FORM_FIELD_CHANGED'),
      debounceTime(3_000, scheduler),
      withLatestFrom(state$),
      filter(([{ tabId }, state]) => getWorkspaceType(state, tabId) === 'secondaryMarketPostEvents'),
      map(([{ tabId }, _]) => tabId),
    );
    return merge(modifyForm$, newForm$).pipe(
      withLatestFrom(state$),
      mergeMap(([tabId, state]) => {
        const persistedTabContent = limitOrderInputFormSelectors.getAmendFormTabContentToPersist(state, tabId);
        if (persistedTabContent === undefined) {
          return EMPTY;
        }
        return of(
          limitOrderInputFormActions.tabContentPersistenceRequested(
            tabId,
            'secondaryMarketPostEvents',
            persistedTabContent,
          ),
        );
      }),
    );
  };
}
